<template>
  <div>
    <div class="pop-wrap" @touchmove.prevent v-if="h_visible">
        <div 
            class="pop-mask" 
            :style="{ background: '#' + bg_color_color , opacity: bg_color_opacity }"
            @click="clickCloseDialog()">
        </div>
        <div class="pop-body" ref="refpop">
            <!-- 活动区域信息 -->
            <InfoActivity 
                v-model="goodinfo.charge_activity"
                />

            <div style="background: white;border-radius: 3%;">
                <!-- 用户信息 -->
                <InfoUser 
                    v-model="userinfo"
                    @res="clickCloseDialog()"/>

                <div class="bg_white">
                    <div class="pop-body-bd">
                        <!-- 支付档位 -->
                        <GoodList
                            :h_data_good="goods"
                            :h_data_goodinfo="goodinfo"
                            :j_req="j_req"
                            :choise_good_num="choise_num"
                            :h_visible_hascoupon="hascoupon"
                            @clickRealGoods="clickChoiseGood"
                        />

                        <!-- 超级赠礼 -->
                        <GoodGift
                            :h_data_good="goods"
                            :h_data_goodinfo="goodinfo"
                            :j_req="j_req"
                            @clickMarketBtn="clickChoiseGood"
                        />
                        <div style="position: relative;background: white;">
                            <!-- 提示信息 -->
                            <GoodTip
                                :h_data_goodinfo="goodinfo"
                            />

                            <!-- 优惠券显示 -->
                            <GoodCoupon
                                :h_data_goodinfo="goodinfo"
                                :h_visible_hascoupon="hascoupon"
                                :j_req="j_req"
                                @changeCoupon="changeCoupon"
                            />

                            <!-- 支付按钮 -->
                            <PayButton
                                :h_data_userinfo="userinfo"
                                :h_data_goodinfo="goodinfo"
                                :j_req="j_req"
                                :h_visible_hascoupon="hascoupon"
                                @clickJumpPay="clickJumpPay"
                            />
                        </div>
                        
                    </div>
                    <!-- 点击跳转 -->
                    <JumpEvent :j_req="j_req"/>
                </div>
            </div>
        </div>
    </div>
    <!-- loading -->
    <Loading :visible="h_loading"/>
    <!-- 收银台组件 -->
    <cashdesk 
        ref="cashdesk"
        :visible.sync="visible_cashdesk"
        :param="param_cashdesk" 
        @payMessage="receiveCashdeskPayMessage"
        @errorMessage="receiveCashdeskErrorMessage"
    />
  </div>
</template>
 
<script>
//组件
import cashdesk from '../../cashdesk/src/cashdesk'
import InfoActivity from '../comp/InfoActivity'
import InfoUser from '../comp/InfoUser'
import JumpEvent from '../comp/JumpEvent'
import GoodList from '../comp/GoodList'
import GoodGift from '../comp/GoodGift'
import GoodCoupon from '../comp/GoodCoupon'
import GoodTip from '../comp/GoodTip'
import PayButton from '../comp/PayButton'
//组件
import Loading from '../../common/Loading'
import slide from "../../../assets/animation/slide";

//公用方法 - 全局
import {
    toast,
    debug,
    ua,
    getDeepVal,
    fenToYuan
} from '@kkmh/utils'
//组件方法 - 局部
import {getPayParam} from "../../../assets/utils";
import {
    getBaseParam,
    checkParamPassed,
    getVipViewData,
    getVipList,
    openMission,
    getOrderInfo,
    payAfterMustDelCoupon,
} from "../js/common";
import {
    formatCoupon,
} from "../js/comp";
import {doTrackPv,doTrackPvYingxiao,doTrackClick} from "../js/track";
export default {
    components: {
        cashdesk,
        InfoActivity,
        InfoUser,
        JumpEvent,
        GoodList,
        GoodGift,
        GoodCoupon,
        GoodTip,
        PayButton,
        Loading,
    },
    name: 'VipHalfScreen',
        data () {
        return {
            h_loading           : false,
            h_visible           : false,
            swiperOption        : {
                // autoplay: true,//可选选项，自动滑动
                // slidesPerView: 'auto', //5.1,
                slidesPerView: 3.3, //5.1,
                // loopedSlides: 4,
            },
            //收银台参数
            visible_cashdesk    : false,
            param_cashdesk      : {},
            vipdata             : {},
            j_req               : {},
            btn_name            : '',
        }
    },
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        param:{
            type: Object,
            default: () => {
                return {}
            }
        },
    },
    watch:{
        visible:{
            handler(val){
                if(val) {
                    // 调用者先设置param然后设置visible，setTimeout可以解决此顺序正确赋值
                    setTimeout(() => {
                        this.h_loading = true;
                        this.init();
                        this.notifyResetVisibleFalse();
                    },0);
                }
            },
            deep:true
        },
        param:{
            handler(val){
                this.j_req = JSON.parse(JSON.stringify(val));
            },
            deep:true
        },
    },
    computed: {
        bg_color_color(){
            return getDeepVal(this.j_req,'bg_color.color','');
        },
        bg_color_opacity(){
            let v = this.j_req.bg_color || {};
            if(v.opacity) {
                return parseFloat(v.opacity);
            }
            if (v.opacity == 0) {
                return 0;
            }
        },
        userinfo(){
            return {
                user : this.vipdata.user || {},
                vip_user : this.vipdata.vip_user || {},
            }
        },
        goods(){
            return this.vipdata.goods || [];
        },
        goodinfo(){
            if (getDeepVal(this.vipdata,'choise.id','')) {
                let item = this.vipdata.goods[getDeepVal(this.vipdata,'choise.num',0)];
                item = {
                    ...item,
                    ...formatCoupon(item),
                }
                return item;
            }
            return {};
        },
        choise_num(){
            return getDeepVal(this.vipdata,'choise.num',0);
        },
        hascoupon(){
            return getDeepVal(this.vipdata,'hascoupon',false);
        },
    },
    methods:{
        init(){
            (async () => {
                this.j_req = await getBaseParam(this.j_req);
                let {code, data={}, message} = await checkParamPassed(this.j_req);
                if (code !== 200) {
                    this.notifyErrorMessage(code, message);
                    return null;
                }
                let issuccess = await this.getViewData();

                if (issuccess) {
                    this.openDialog();    
                }
            })();
        },
        async getViewData(){
            let {code, data, message} = await getVipViewData(this.j_req);
            if (code !== 200) {
                this.notifyErrorMessage(code, message);
                return false;
            }
            this.vipdata = data || {};
            // console.log(JSON.parse(JSON.stringify(this.vipdata)));
            return true;
        },
        //优惠券选中重新刷新
        changeCoupon(){
            this.vipdata.goods = JSON.parse(JSON.stringify(this.vipdata.goods));
        },
        // 开启-半屏
        openDialog(){
            this.h_loading = false;
            this.h_visible = true;
            this.$nextTick(() => {
                slide.up(this.$refs.refpop, () => {
                    
                });
            })
            openMission(this.j_req).then(res => {
                // 半屏pv上报
                doTrackPv(this.j_req);
                // 营销区域上报
                doTrackPvYingxiao(this.j_req, this.goodinfo.display_info);
            });
            this.notifyDialogOpen();
        },
        // 关闭-半屏
        closeDialog(){
            slide.down(this.$refs.refpop);
            setTimeout(() => {
                this.h_visible = false;//关闭时为了有slide效果
            },300)
            this.notifyDialogClose();
        },
        // vip半屏组件-通知 : 拉起
        notifyDialogOpen(){
            debug(`【vip半屏 - 拉起】`);
            this.$emit('dialogOpen');
        },
        // vip半屏组件-通知 : 关闭
        notifyDialogClose(){
            debug(`【vip半屏 - 关闭】`);
            this.$emit('dialogClose');
        },
        // vip半屏组件-通知 : 支付信息
        notifyPayMessage(res){
            debug(`【vip半屏 - 支付信息】`, res);
            this.$emit('payMessage', res);
        },
        // vip半屏组件-通知 : 出错
        notifyErrorMessage(code, message, data={}){
            debug(`【vip半屏 - 出错信息】`);
            this.h_loading = false;
            let info = ua.prod ? `${message}` : `[${code}]-${message}`;
            toast(`拉起遇到问题~ ${info}`);
            this.$emit("errorMessage", {code, data, message});
        },
        // vip半屏组件-通知 : 更新visible重制才能重新点击打开
        notifyResetVisibleFalse(){
            // debug(`【vip半屏 - 重制visible】`);
            this.$emit('update:visible', false);
        },
        // vip半屏组件-通知 : 商品列表信息 kkb （父组件通过ref可以调用）
        getListData(){
            setTimeout(() => {
                (async () => {
                    let opt = await getBaseParam(this.j_req);
                    let res = await getVipList(opt);
                    debug(`【收银台 - 商品列表信息】`,res);
                    this.$emit('listData',res);
                })()
            },0);
        },

        clickCloseDialog(){
            this.closeDialog();
        },
        // 切换档位
        clickChoiseGood(obj) {
            this.goods.forEach((item, index) => {
                if (obj.id == item.id) {
                    this.$set(this.vipdata, 'choise', {
                        id : item.id,
                        num : index,
                    });
                }
            })
        },
        // 支付商品
        clickJumpPay(btn_name) {
            this.btn_name = btn_name;
            this.param_cashdesk = getPayParam({
                ...this.j_req,
                good_id         : this.goodinfo.id,  //必须-int 76
                coupon_id       : this.goodinfo.couponid,
                send_comic      : getDeepVal(this.goodinfo, 'comboinfo.send_comic', ''),
                free_pay_rate   : getDeepVal(this.goodinfo, 'comboinfo.free_pay_rate', ''),
            });
            this.visible_cashdesk = true;
        },
        // 收银台组件-接收 : 收银台操作
        receiveCashdeskPayMessage(res){
            (async () => {
                let {code, data={}, message} = res;
                data.good_info = JSON.parse(JSON.stringify(this.goodinfo));
                data.btn_name  = this.btn_name;

                // 3取消时等于直接关闭弹窗，未下单所以不要刷新优惠券
                if(data.pay_status !== 3) {
                    this.vipdata.goods = payAfterMustDelCoupon(this.vipdata.goods, this.goodinfo);
                }
                // 支付成功后
                if(data.pay_status == 1) {
                    await this.getViewData();//需要更新swiper
                    data.fuli_info = await getOrderInfo();
                }
                // 
                if(data.pay_status == 7) {
                    // 当前为越狱商品 && 支付方式选中了iap支付
                    if ( this.goodinfo.recharge_type==1 && data.pay_payment.type == 4 ) {
                        // 需要刷新接口
                        this.h_loading = true;
                        this.j_req.compel_iap = true;//勾选越狱商品选择用iap支付时传递true 
                        await this.getViewData();//重新刷新接口
                        toast('支付环境已更新,请重新选择支付');
                    }
                }
                this.notifyPayMessage({code, data, message});
            })();
        },
        // 收银台组件-接收 : 出错
        receiveCashdeskErrorMessage({code=0, message='', data={}} = {}){
            this.notifyErrorMessage(code, message, data);
        },
    },
}

</script>


<style lang="scss">
@import "../../../assets/styles/flex.css";
.pop-wrap {
    * {padding: 0;margin: 0;box-sizing: border-box;font-family: PingFangSC-Regular, -apple-system-font,"Helvetica Neue","PingFang SC","Hiragino Sans GB","Microsoft YaHei",sans-serif}
    ul,li,dl,ol {list-style: none; }
    em,i {font-style: normal; }
    img {width: 100%;vertical-align: middle;border: none;}
    a, img {-webkit-touch-callout: none; pointer-events: none;/* 禁止长按链接与图片弹出菜单 */}
    .hide,.opacity0{opacity:0;}
    .pf-medium{font-weight:500;font-family: PingFangSC-Regular, -apple-system-font,"Helvetica Neue","PingFang SC","Hiragino Sans GB","Microsoft YaHei",sans-serif!important;}
    .pf-semibold{font-weight:600;font-family: PingFangSC-Regular, -apple-system-font,"Helvetica Neue","PingFang SC","Hiragino Sans GB","Microsoft YaHei",sans-serif!important;}
    .pf-regular{font-family: PingFangSC-Regular, -apple-system-font,"Helvetica Neue","PingFang SC","Hiragino Sans GB","Microsoft YaHei",sans-serif!important;}
}
</style>
<style lang="scss" scoped>
@import "../../../assets/styles/mixins.scss";
.pop-wrap.show{display:block;}
.pop-wrap{
    z-index:998;position: fixed;left:0;top:0;height:100%;width:100%;overflow: hidden;
    .pop-mask{
        position: absolute;left:0;top:0;height:100%;width:100%;overflow: hidden;background: rgba(0,0,0,.5);
    }
    .pop-body{
        transform: translate3d(0,100%,0);
        position: absolute;left:0;bottom:0;width:100%;font-size: vws(24px);color:#000;
        .bg_white{
            background: #fff;
            .pop-body-bd{
                padding-top: vws(16px)
            }
        }
    }
}
.slideon {
    animation: slideUp .2s 0s linear both;
}
.slideoff {
    animation: slideDown .2s 0s linear both;
}

@keyframes slideUp {
    100% {
        transform: translate3d(0,0,0);
    }
}

@keyframes slideDown {
    0% {
        transform: translate3d(0,0,0);
    }
    100% {
        transform: translate3d(0,100%,0);
    }
}




</style>













// WEBPACK FOOTER //
// node_modules/@kkmh/pays/src/components/viphalfscreen/src/viphalfscreen.vue